import firebase from "firebase";
import GeoFire from "geofire";

var config = {
  apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
  authDomain: "tourbrazil-41fbe.firebaseapp.com",
  databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
  projectId: "tourbrazil-41fbe",
  storageBucket: "tourbrazil-41fbe.appspot.com",
  messagingSenderId: "927605208400"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const Titulo = e => {
  return dispatch => {
    return dispatch({
      type: "TITLE",
      payload: e
    });
  };
};

export const Conteudo = e => {
  return dispatch => {
    return dispatch({
      type: "CONTENT",
      payload: e
    });
  };
};

export const Img = e => {
  return dispatch => {
    dispatch({ type: "SEND_STATE", payload: "Aguarde, Enviando Imagem..." });
    var file = e.target.files[0];

    // Referenciar o Storage
    var storageRef = firebase.storage().ref("promoImg/" + file.name);

    // Enviar o arquivo
    var task = storageRef
      .put(file)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
      })

      .then(downloadURL => {
        console.log(
          `Successfully uploaded file and got download link - ${downloadURL}`
        );
        dispatch({ type: "SEND_STATE", payload: "" });
        return dispatch({ type: "IMG", payload: downloadURL });
      })

      .catch(error => {
        // Use to signal error if something goes wrong.
        console.log(`Failed to upload file and get link - ${error}`);
      });
  };
};

export const Valor = e => {
  return dispatch => {
    return dispatch({
      type: "VALOR",
      payload: e
    });
  };
};

export const Promocao = e => {
  return dispatch => {
    return dispatch({
      type: "PROMOCAO",
      payload: e
    });
  };
};

export const Link = e => {
  return dispatch => {
    return dispatch({
      type: "LINK",
      payload: e
    });
  };
};

export const Send = (conteudo, nome, promo, valor, email, img, link, Tval) => {
  return dispatch => {
    dispatch({ type: "SEND_STATE", payload: "Enviando dados" });
    var emailB64 = btoa(email);
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    var today = dd + "/" + mm + "/" + yyyy;
    var vencimento = null;

    function SomarData(txtData, DiasAdd) {
      dispatch({ type: "SEND_STATE", payload: "Verificando Validade" });
      var d = new Date();
      d.setTime(
        Date.parse(
          txtData
            .split("/")
            .reverse()
            .join("/")
        ) +
          86400000 * DiasAdd
      );

      var DataFinal;
      if (d.getDate() < 10) {
        DataFinal = "0" + d.getDate().toString();
      } else {
        DataFinal = d.getDate().toString();
      }

      if (d.getMonth() + 1 < 10) {
        DataFinal +=
          "/0" +
          (d.getMonth() + 1).toString() +
          "/" +
          d.getFullYear().toString();
      } else {
        DataFinal +=
          "/" +
          (d.getMonth() + 1).toString() +
          "/" +
          d.getFullYear().toString();
      }
      vencimento = DataFinal;
    }
    SomarData(today, Tval);
    firebase.auth().onAuthStateChanged(user => {
      firebase
        .database()
        .ref("/promocoes/" + user.uid)
        .push({
          conteudo: conteudo,
          nome: nome,
          promocao: promo,
          valor: valor,
          key: user.uid,
          img: img,
          dataPost: today,
          vencimento: vencimento,
          link: link
        })
        .then(value => {
          return dispatch({
            type: "SEND_STATE",
            payload: "Nova promoção enviada"
          });
        })
        .catch(erro => {
          console.log(erro);
          return dispatch({
            type: "SEND_STATE",
            payload: "Erro ao cadastrar sua promoção"
          });
        });
    });
  };
};

export const Editar = (
  conteudo,
  nome,
  promo,
  valor,
  email,
  img,
  link,
  Tval,
  id,
  oldImg
) => {
  return dispatch => {
    dispatch({ type: "SEND_STATE", payload: "Enviando dados" });
    var emailB64 = btoa(email);
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    var today = dd + "/" + mm + "/" + yyyy;
    var vencimento = null;

    function SomarData(txtData, DiasAdd) {
      dispatch({ type: "SEND_STATE", payload: "Verificando Validade" });
      var d = new Date();
      d.setTime(
        Date.parse(
          txtData
            .split("/")
            .reverse()
            .join("/")
        ) +
          86400000 * DiasAdd
      );

      var DataFinal;
      if (d.getDate() < 10) {
        DataFinal = "0" + d.getDate().toString();
      } else {
        DataFinal = d.getDate().toString();
      }

      if (d.getMonth() + 1 < 10) {
        DataFinal +=
          "/0" +
          (d.getMonth() + 1).toString() +
          "/" +
          d.getFullYear().toString();
      } else {
        DataFinal +=
          "/" +
          (d.getMonth() + 1).toString() +
          "/" +
          d.getFullYear().toString();
      }
      vencimento = DataFinal;
    }
    SomarData(today, Tval);
    firebase.auth().onAuthStateChanged(user => {
      firebase
        .database()
        .ref(`/promocoes/${user.uid}/${id}`)
        .set({
          conteudo: conteudo,
          nome: nome,
          promocao: promo,
          valor: valor,
          key: user.uid,
          img: img ? img : oldImg,
          dataPost: today,
          vencimento: vencimento,
          link: link
        })
        .then(value => {
          return dispatch({
            type: "SEND_STATE",
            payload: "Nova promoção enviada"
          });
        })
        .catch(erro => {
          console.log(erro);
          return dispatch({
            type: "SEND_STATE",
            payload: "Erro ao cadastrar sua promoção"
          });
        });
    });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/promo.js